export default class BasicLoader {
	constructor(url) {
		console.log("Initializing a loader with url " + url)
		this.url = url
	}
	execute() {

	}
}